export default "__VITE_ASSET__DJNiUXDZ__"